import { Config } from "../../interfaces/config";

/**
 * Determines the incentive view ID based on award code, period, and user country
 * @param awardCode - The award code to check (e.g., 940 for Performance Plus)
 * @param currentPeriod - Current selected period (e.g., "202507")
 * @param configuration - Market configuration
 * @param userCountry - User's country code (e.g., "AT", "US")
 * @returns The viewId (e.g., "PPv2") if conditions are met, null otherwise
 */
export const getIncentiveViewID = (
  awardCode: number,
  currentPeriod: string,
  configuration: Config,
  userCountry: string,
): string => {
  const incentiveViews = configuration.incentiveViews || [];

  const matchingView = incentiveViews.find(
    (view) =>
      view.awardCode === awardCode &&
      view.countries.includes(userCountry) &&
      parseInt(currentPeriod) >= view.startPeriod,
  );

  return matchingView?.viewId || "";
};
